/** The session is considered expired if twice the lifetime of the token has elapsed */
export const sessionExpired = (sessionExpires: Date): boolean => {
  return new Date() > sessionExpires;
};
